import axios from 'axios';
import { config } from '../config/config';
import {ApiRefreshTokenService} from "./index";
import {authModel} from "../../entities/auth";
import {getAccessToken, setTokens} from "../lib/session";

export const apiInstance = axios.create({
  baseURL: `${config.API_HOST}/api`,
});

apiInstance.interceptors.request.use((requestConfig) => {
  requestConfig.headers.Authorization = `Bearer ${getAccessToken()}`;
  return requestConfig;
});

let refreshingTokenPromise = null

apiInstance.interceptors.response.use(
  response => {
    return response;
  },
  async (error) => {
    if (error.response.status === 401 && !error.config._retry){
      const queryConfig = error.config;

      const isExpiredRefreshToken = queryConfig.url === 'auth/refreshToken'
      if (isExpiredRefreshToken) {
        authModel.logout()
        return Promise.reject(error)
      }

      queryConfig._retry = true;
      try {
        refreshingTokenPromise = refreshingTokenPromise ? refreshingTokenPromise : ApiRefreshTokenService.refreshAccessToken()
        const response = await refreshingTokenPromise
        refreshingTokenPromise = null

        const { accessToken, refreshToken } = response.data;
        setTokens(accessToken, refreshToken);
        return apiInstance(queryConfig);

      } catch (_err) {
        refreshingTokenPromise = null
        return Promise.reject(_err)
      }
    }
    return Promise.reject(error)
  }
);
